import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function MapLayersBackButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="tw:h-8 tw:justify-start tw:px-1 tw:text-xs"
      onClick={onClick}
    >
      <ArrowLeft className="tw:size-4" />
      Map Layers
    </Button>
  );
}
